export const DEFAULT_WEBHOOK_TEMPLATE = '{\n  {{- /* Please use Go-template syntax for the Custom Template */ -}}\n}\n';

export const DEFAULT_EMAIL_SUBJECT_TEMPLATE =
  'Sample Subject. {{- /* Custom email subject template - Go-template syntax */ -}}';

export const DEFAULT_EMAIL_BODY_TEMPLATE = '{{- /* Custom email body template */ -}}\n<p>Sample text.</p>';

// sample DDoS alarm event for template testing
export const DEFAULT_PREVIEW_DATA = JSON.stringify(
  {
    CompanyID: 1002,
    CompanyName: 'ACME Incorporated',
    Now: '2026-01-08T17:30:00Z',
    NowRFC3339: '2026-01-08T17:30:00Z',
    NowDatetime: '2026-01-08 17:30:00 UTC',
    Headline: 'Kentik Alert',
    Summary: 'Alarm for DDoS Protect Policy Active',
    NotificationsSettingsURL: 'https://portal.kentik.com/v4/settings/notifications',
    IsSingleEvent: true,
    IsMultipleEvents: false,
    IsAtLeastOneEvent: true,
    ActiveCount: 1,
    ClearedCount: 0,
    Event: {
      Type: 'alarm',
      Description: 'Alarm for DDoS Protect Policy Active',
      IsAlarm: true,
      IsInsight: false,
      IsMitigation: false,
      IsSynthetic: false,
      IsActive: true,
      IsClear: false,
      StartTime: '2026-01-08 17:15:32 UTC',
      EndTime: 'ongoing',
      CurrentState: 'active',
      PreviousState: 'new',
      StartTimestamp: 1736356532,
      EndTimestamp: 0,
      Importance: 5,
      GroupName: 'Alarm for DDoS Protect Policy',
      Details: [
        {
          Name: 'AlarmID',
          Label: 'ID',
          Value: '0190db1d-5d37-70a8-95bd-4092c918ecbe',
          Tag: ''
        },
        {
          Name: 'AlarmKey',
          Label: 'Alarm Key',
          Value: 'alarm_297_14444_209.50.158.100_1234',
          Tag: ''
        },
        {
          Name: 'AlarmSeverity',
          Label: 'Severity',
          Value: 'major',
          Tag: ''
        },
        {
          Name: 'AlarmSeverityLabel',
          Label: 'Severity Label',
          Value: 'Major',
          Tag: ''
        },
        {
          Name: 'AlarmPolicyName',
          Label: 'Source Policy Name',
          Value: 'DDoS Protect Policy',
          Tag: ''
        },
        {
          Name: 'AlarmPolicyLabels',
          Label: 'Policy Labels',
          Value: 'security, ddos, critical-infrastructure',
          Tag: ''
        },
        {
          Name: 'AlarmPolicyID',
          Label: 'Policy ID',
          Value: 297,
          Tag: ''
        },
        {
          Name: 'AlarmThresholdID',
          Label: 'Threshold ID',
          Value: 14444,
          Tag: ''
        },
        {
          Name: 'Baseline',
          Label: 'Baseline Value',
          Value: 3076,
          Tag: ''
        },
        {
          Name: 'AlarmBaselineSource',
          Label: 'Baseline Source',
          Value: 'ACT_BASELINE_MISSING_DEFAULT_INSTEAD_OF_LOWEST',
          Tag: ''
        },
        {
          Name: 'CompanyID',
          Label: 'Company ID',
          Value: 1002,
          Tag: ''
        },
        {
          Name: 'IP_dst',
          Label: 'Dest IP/CIDR',
          Value: '209.50.158.100',
          Tag: 'dimension'
        },
        {
          Name: 'i_device_id',
          Label: 'Device ID',
          Value: 1234,
          Tag: 'dimension'
        },
        {
          Name: 'Geography',
          Label: 'Geography',
          Value: 'US',
          Tag: 'dimension'
        },
        {
          Name: 'proto',
          Label: 'Protocol',
          Value: 'UDP',
          Tag: 'dimension'
        },
        {
          Name: 'DeviceName',
          Label: 'Device',
          Value: 'edge-router-nyc-01',
          Tag: 'device'
        },
        {
          Name: 'DeviceType',
          Label: 'Device Type',
          Value: 'router',
          Tag: 'device'
        },
        {
          Name: 'DeviceLabels',
          Label: 'Device Labels',
          Value: 'production, edge, nyc-datacenter',
          Tag: 'device'
        },
        {
          Name: 'bits',
          Label: 'Bits/s',
          Value: 58555.9140625,
          Tag: 'metric'
        },
        {
          Name: 'packets',
          Label: 'Packets/s',
          Value: 11.200035095214844,
          Tag: 'metric'
        },
        {
          Name: 'unique_src_ip',
          Label: 'Unique Source IPs',
          Value: 1,
          Tag: 'metric'
        },
        {
          Name: 'bytes',
          Label: 'Bytes',
          Value: 7319489.25,
          Tag: 'metric'
        },
        {
          Name: 'DashboardAlarmURL',
          Label: 'Dashboard',
          Value: 'https://portal.kentik.com/v4/alerting/a/0190db1d-5d37-70a8-95bd-4092c918ecbe',
          Tag: 'url'
        },
        {
          Name: 'DetailsAlarmURL',
          Label: 'Explorer',
          Value: 'https://portal.kentik.com/v4/core/explorer?query=...',
          Tag: 'url'
        },
        {
          Name: 'MitigationURL',
          Label: 'Mitigation',
          Value:
            'https://portal.kentik.com/v4/protect/mitigations/create?alarm_id=0190db1d-5d37-70a8-95bd-4092c918ecbe',
          Tag: 'url'
        },
        {
          Name: 'TotalAlarmsActive',
          Label: 'Total Active Alarms',
          Value: 3,
          Tag: 'statistic'
        },
        {
          Name: 'TotalAlarmsCleared',
          Label: 'Total Cleared Alarms',
          Value: 0,
          Tag: 'statistic'
        },
        {
          Name: 'SecurityLabel',
          Label: 'Security',
          Value: {
            Color: '#ff0000',
            IsDark: true,
            Name: 'Critical Security Event'
          },
          Tag: 'label'
        }
      ]
    },
    Events: [
      {
        Type: 'alarm',
        Description: 'Alarm for DDoS Protect Policy Active',
        IsAlarm: true,
        IsInsight: false,
        IsMitigation: false,
        IsSynthetic: false,
        IsActive: true,
        IsClear: false,
        StartTime: '2026-01-08 17:15:32 UTC',
        EndTime: 'ongoing',
        CurrentState: 'active',
        PreviousState: 'new',
        StartTimestamp: 1736356532,
        EndTimestamp: 0,
        Importance: 5,
        GroupName: 'Alarm for DDoS Protect Policy',
        Details: [
          {
            Name: 'AlarmID',
            Label: 'ID',
            Value: '0190db1d-5d37-70a8-95bd-4092c918ecbe',
            Tag: ''
          },
          {
            Name: 'AlarmKey',
            Label: 'Alarm Key',
            Value: 'alarm_297_14444_209.50.158.100_1234',
            Tag: ''
          },
          {
            Name: 'AlarmSeverity',
            Label: 'Severity',
            Value: 'major',
            Tag: ''
          },
          {
            Name: 'AlarmSeverityLabel',
            Label: 'Severity Label',
            Value: 'Major',
            Tag: ''
          },
          {
            Name: 'AlarmPolicyName',
            Label: 'Source Policy Name',
            Value: 'DDoS Protect Policy',
            Tag: ''
          },
          {
            Name: 'AlarmPolicyLabels',
            Label: 'Policy Labels',
            Value: 'security, ddos, critical-infrastructure',
            Tag: ''
          },
          {
            Name: 'AlarmPolicyID',
            Label: 'Policy ID',
            Value: 297,
            Tag: ''
          },
          {
            Name: 'AlarmThresholdID',
            Label: 'Threshold ID',
            Value: 14444,
            Tag: ''
          },
          {
            Name: 'Baseline',
            Label: 'Baseline Value',
            Value: 3076,
            Tag: ''
          },
          {
            Name: 'AlarmBaselineSource',
            Label: 'Baseline Source',
            Value: 'ACT_BASELINE_MISSING_DEFAULT_INSTEAD_OF_LOWEST',
            Tag: ''
          },
          {
            Name: 'CompanyID',
            Label: 'Company ID',
            Value: 1002,
            Tag: ''
          },
          {
            Name: 'IP_dst',
            Label: 'Dest IP/CIDR',
            Value: '209.50.158.100',
            Tag: 'dimension'
          },
          {
            Name: 'i_device_id',
            Label: 'Device ID',
            Value: 1234,
            Tag: 'dimension'
          },
          {
            Name: 'Geography',
            Label: 'Geography',
            Value: 'US',
            Tag: 'dimension'
          },
          {
            Name: 'proto',
            Label: 'Protocol',
            Value: 'UDP',
            Tag: 'dimension'
          },
          {
            Name: 'DeviceName',
            Label: 'Device',
            Value: 'edge-router-nyc-01',
            Tag: 'device'
          },
          {
            Name: 'DeviceType',
            Label: 'Device Type',
            Value: 'router',
            Tag: 'device'
          },
          {
            Name: 'DeviceLabels',
            Label: 'Device Labels',
            Value: 'production, edge, nyc-datacenter',
            Tag: 'device'
          },
          {
            Name: 'bits',
            Label: 'Bits/s',
            Value: 58555.9140625,
            Tag: 'metric'
          },
          {
            Name: 'packets',
            Label: 'Packets/s',
            Value: 11.200035095214844,
            Tag: 'metric'
          },
          {
            Name: 'unique_src_ip',
            Label: 'Unique Source IPs',
            Value: 1,
            Tag: 'metric'
          },
          {
            Name: 'bytes',
            Label: 'Bytes',
            Value: 7319489.25,
            Tag: 'metric'
          },
          {
            Name: 'DashboardAlarmURL',
            Label: 'Dashboard',
            Value: 'https://portal.kentik.com/v4/alerting/a/0190db1d-5d37-70a8-95bd-4092c918ecbe',
            Tag: 'url'
          },
          {
            Name: 'DetailsAlarmURL',
            Label: 'Explorer',
            Value: 'https://portal.kentik.com/v4/core/explorer?query=...',
            Tag: 'url'
          },
          {
            Name: 'MitigationURL',
            Label: 'Mitigation',
            Value:
              'https://portal.kentik.com/v4/protect/mitigations/create?alarm_id=0190db1d-5d37-70a8-95bd-4092c918ecbe',
            Tag: 'url'
          },
          {
            Name: 'TotalAlarmsActive',
            Label: 'Total Active Alarms',
            Value: 3,
            Tag: 'statistic'
          },
          {
            Name: 'TotalAlarmsCleared',
            Label: 'Total Cleared Alarms',
            Value: 0,
            Tag: 'statistic'
          },
          {
            Name: 'SecurityLabel',
            Label: 'Security',
            Value: {
              Color: '#ff0000',
              IsDark: true,
              Name: 'Critical Security Event'
            },
            Tag: 'label'
          }
        ]
      }
    ],
    Config: {
      BaseDomain: 'portal.kentik.com',
      EmailTo: ['security-team@acme.com', 'noc@acme.com']
    }
  },
  null,
  2
);

export const TEMPLATE_KEY_CUSTOM_SUBJECT = 'customSubjectTemplate';
export const TEMPLATE_KEY_CUSTOM_BODY = 'customBodyTemplate';
export const TEMPLATE_KEY_CUSTOM_TEMPLATE = 'customTemplate';

export const getTemplateFieldName = (activeTemplateKey) => {
  if (activeTemplateKey === TEMPLATE_KEY_CUSTOM_SUBJECT) {
    return 'config.renderingConfig.emailConfig.customSubjectTemplate';
  }

  if (activeTemplateKey === TEMPLATE_KEY_CUSTOM_BODY) {
    return 'config.renderingConfig.emailConfig.customBodyTemplate';
  }

  return 'config.renderingConfig.customTemplate';
};

export const getDefaultTemplateForKey = (activeTemplateKey) => {
  switch (activeTemplateKey) {
    case TEMPLATE_KEY_CUSTOM_SUBJECT:
      return DEFAULT_EMAIL_SUBJECT_TEMPLATE;
    case TEMPLATE_KEY_CUSTOM_BODY:
      return DEFAULT_EMAIL_BODY_TEMPLATE;
    case TEMPLATE_KEY_CUSTOM_TEMPLATE:
    default:
      return DEFAULT_WEBHOOK_TEMPLATE;
  }
};
